export const getLpProductV2Sort = (
  searchParams: Pick<URLSearchParams, 'get'>,
  fallbackSort?: string
): string | undefined => searchParams.get('sort') || fallbackSort;
